export default "__VITE_PUBLIC_ASSET__7ef5698f__"